
import React from "react";
import { Linkedin, Instagram, Youtube } from "lucide-react";
import { FaTiktok } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { SiXiaohongshu } from "react-icons/si";

type SocialIconProps = {
  size?: number;
  className?: string;
}

export const LinkedinIcon = ({ size = 20, className = "" }: SocialIconProps) => (
  <div className={`flex items-center justify-center bg-[#0077B5] text-white p-1.5 rounded-md ${className}`}>
    <Linkedin size={size} />
  </div>
);

export const XiaohongshuIcon = ({ size = 20, className = "" }: SocialIconProps) => (
  <div className={`flex items-center justify-center bg-red-600 text-white p-1.5 rounded-md ${className}`}>
    <SiXiaohongshu size={size} />
  </div>
);

export const BilibiliIcon = ({ size = 20, className = "" }: SocialIconProps) => (
  <div className={`flex items-center justify-center bg-[#ff66cc] text-white p-1.5 rounded-md ${className}`}>
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.813 4.653h.854c1.51.054 2.769.578 3.773 1.574 1.004.995 1.524 2.249 1.56 3.76v7.36c-.036 1.51-.556 2.769-1.56 3.773s-2.262 1.524-3.773 1.56H5.333c-1.51-.036-2.769-.556-3.773-1.56S.036 18.858 0 17.347v-7.36c.036-1.511.556-2.765 1.56-3.76 1.004-.996 2.262-1.52 3.773-1.574h.774l-1.174-1.12a1.234 1.234 0 0 1-.373-.906c0-.356.124-.658.373-.907l.027-.027c.267-.249.573-.373.92-.373.347 0 .653.124.92.373L9.653 4.44c.071.071.134.142.187.213h4.267a.836.836 0 0 1 .16-.213l2.853-2.747c.267-.249.573-.373.92-.373.347 0 .662.151.929.4.267.249.391.551.391.907 0 .356-.124.657-.373.906L17.813 4.653zM5.333 7.24c-.746.018-1.373.276-1.88.773-.506.498-.769 1.13-.789 1.893v7.52c.02.764.283 1.395.789 1.893.507.498 1.134.756 1.88.773h13.334c.746-.017 1.373-.275 1.88-.773.506-.498.769-1.129.789-1.893v-7.52c-.02-.763-.283-1.395-.789-1.893-.507-.497-1.134-.755-1.88-.773H5.333zM8 11.107c.373 0 .684.124.933.373.25.249.383.569.4.96v1.173c-.017.391-.15.711-.4.96-.249.25-.56.374-.933.374s-.684-.125-.933-.374c-.25-.249-.383-.569-.4-.96V12.44c.017-.391.15-.711.4-.96.249-.249.56-.373.933-.373zm8 0c.373 0 .684.124.933.373.25.249.383.569.4.96v1.173c-.017.391-.15.711-.4.96-.249.25-.56.374-.933.374s-.684-.125-.933-.374c-.25-.249-.383-.569-.4-.96V12.44c.017-.391.15-.711.4-.96.249-.249.56-.373.933-.373z"/>
    </svg>
  </div>
);

export const YoutubeIcon = ({ size = 20, className = "" }: SocialIconProps) => (
  <div className={`flex items-center justify-center bg-red-600 text-white p-1.5 rounded-md ${className}`}>
    <Youtube size={size} />
  </div>
);

export const InstagramIcon = ({ size = 20, className = "" }: SocialIconProps) => (
  <div className={`flex items-center justify-center bg-gradient-to-tr from-purple-600 via-pink-500 to-orange-400 text-white p-1.5 rounded-md ${className}`}>
    <Instagram size={size} />
  </div>
);

export const TiktokIcon = ({ size = 20, className = "" }: SocialIconProps) => (
  <div className={`flex items-center justify-center bg-foreground text-background p-1.5 rounded-md ${className}`}>
    <FaTiktok size={size} />
  </div>
);

export const XIcon = ({ size = 20, className = "" }: SocialIconProps) => (
  <div className={`flex items-center justify-center bg-foreground text-background p-1.5 rounded-md ${className}`}>
    <FaXTwitter size={size} />
  </div>
);
